import Radio from "backbone.radio";
import moment from "moment";

import { store } from "common/store";

import { references } from "common/helpers/references";

import { merchantDemoPickerFactory } from "merchant/features/merchantPickerView/merchantDemoPicker";

export function PackageInfo({ trialEndDate, merchantID, merchantName, packageRef }) {
    const getPackageInfo = () => {
        const packageInfo = references.toAlias(store.getState().common.merchant_config.package_ref, "package");
        
        let trial = null;
        if (packageInfo.showcountdown && trialEndDate) {
            const trialEndDateMoment = moment.utc(trialEndDate);
            trial = {
                days_remaining: Math.max(0, trialEndDateMoment.diff(moment.utc().subtract(1, "days"), "days")),
                expire_date: trialEndDateMoment.subtract(1, "days").format("MMM D, YYYY")
            };
        }
    
        const packageOverride = localStorage.getItem("package-override");
        
        if (packageOverride === "demo_Lite" && packageInfo.display_name !== "Lite") {
            packageInfo.display_name = "Lite demo";
        }
    
        if (packageOverride === "demo_Pro" && packageInfo.display_name !== "Pro") {
            packageInfo.display_name = "Pro demo";
        }
    
        if (packageOverride === "demo_All") {
            packageInfo.display_name = "Pro + Add-ons";
        }
    
        return {
            ...packageInfo,
            trial
        };
    };
    
    const showPackageComparison = (e) => {
        e.preventDefault();
        
        Radio.channel("main").request("show:package:compare");
    };
    
    const showPackageSwitcher = (e) => {
        e.preventDefault();
        
        merchantDemoPickerFactory({ merchantID, merchantName, packageRef });
    };
    
    const packageInfo = getPackageInfo();
    
    // Don't show the package info if package has show_compare set to false
    if (!packageInfo.show_compare) {
        return null;
    }
    
    return (
        <div className="package">
            <header>
                <span className="current-package">{packageInfo.display_name}</span>
                {store.getState().common.user_permissions.has_package_demo && <a href="#" className="change-package" onClick={showPackageSwitcher}>change</a>}
            </header>
            {packageInfo.trial
                ? (
                    <div className="countdown pz-popover" onClick={showPackageComparison} data-html="true" data-toggle="popover" data-trigger="hover" data-placement="bottom" data-content={`Your free trial of Pro expires on ${packageInfo.trial.expire_date}<br/>At that time, your account will convert to Lite.`}>
                        Days left in trial: <span>{packageInfo.trial.days_remaining}</span>
                    </div>
                )
                : <div className="compare" onClick={showPackageComparison}>Compare packages</div>}
        </div>
    );
}
